function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A5ACB0",
  d: "M52 46h2v-3h-2zM47 45h2v-3h-2zM42 44h2v-4h-2zM59 72h-2v-4H38v4h-2v-4c0-1.103.897-2 2-2h19c1.103 0 2 .897 2 2v4"
}), React.createElement("path", {
  d: "M57 67h-2v-3c0-.824.261-1.833.591-3.11C56.186 58.588 57 55.435 57 51v-7c0-1.103-.897-2-2-2v-2c2.206 0 4 1.794 4 4v7c0 4.688-.886 8.119-1.473 10.39C57.232 62.53 57 63.431 57 64v3M54 44h-2v-2c0-1.103-.897-2-2-2v-2c2.206 0 4 1.794 4 4v2M49 42h-2v-2c0-1.103-.897-2-2-2v-2c2.206 0 4 1.794 4 4v2M40 67h-2v-2.667L32.2 56.6a1.01 1.01 0 01-.166-.341c-1.491-5.566-3.304-11.749-3.796-12.609-.65-.693-.811-1.7-.419-2.645C28.323 39.787 29.572 39 31 39c2.52 0 3.709 3.003 3.924 3.611l2.971 5.942-1.79.894-3-6a1.002 1.002 0 01-.054-.131C32.848 42.717 32.034 41 31 41c-.749 0-1.187.415-1.333.771-.053.126-.118.364.04.522.59.591 2.006 5.052 4.209 13.262L39.8 63.4c.13.173.2.383.2.6v3",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M36.575 35.231A8.04 8.04 0 0132 28c0-4.411 3.589-8 8-8s8 3.589 8 8a8.039 8.039 0 01-4.571 7.229l-.858-1.806A6.03 6.03 0 0046 28c0-3.309-2.691-6-6-6s-6 2.691-6 6a6.032 6.032 0 003.433 5.425l-.858 1.806",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M50.059 34.546l-1.676-1.092A9.961 9.961 0 0050 28c0-5.514-4.486-10-10-10s-10 4.486-10 10c0 1.945.559 3.831 1.616 5.453l-1.676 1.092A11.958 11.958 0 0128 28c0-6.617 5.383-12 12-12s12 5.383 12 12c0 2.334-.671 4.598-1.941 6.546",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M37 50a1 1 0 01-1-1V28c0-2.206 1.794-4 4-4s4 1.794 4 4v12a1 1 0 11-2 0V28c0-1.103-.897-2-2-2s-2 .897-2 2v21a1 1 0 01-1 1",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M56 28h-2c0-7.72-6.28-14-14-14s-14 6.28-14 14h-2c0-8.822 7.178-16 16-16s16 7.178 16 16",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M68 48h-7v-2h7V10H12v36h13v2H12c-1.103 0-2-.897-2-2V10c0-1.103.897-2 2-2h56c1.103 0 2 .897 2 2v36c0 1.103-.897 2-2 2",
  fill: "#A5ACB0"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M14 47h2V12h-2zM64 44h2V9h-2z"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationTouch = function SvgIconIllustrationTouch(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationTouch;